export const base = 'block border rounded flex-1';

export const sizes = {
  sm: 'px-2 py-1 text-sm',
  md: 'px-4 py-2',
}